module.exports = __webpack_public_path__ + "img/70100101.2089ae9f.png";